import h_fetiche from "@/assets/hero-fetiche.mp4.asset.json";
import h_fetiche_p from "@/assets/hero-fetiche-poster.jpg.asset.json";
import h_primeiro_corte from "@/assets/hero-primeiro-corte.mp4.asset.json";
import h_primeiro_corte_p from "@/assets/hero-primeiro-corte-poster.jpg.asset.json";
import h_6_de_abril from "@/assets/hero-6-de-abril.mp4.asset.json";
import h_6_de_abril_p from "@/assets/hero-6-de-abril-poster.jpg.asset.json";
import h_music_on from "@/assets/hero-music-on.mp4.asset.json";
import h_music_on_p from "@/assets/hero-music-on-poster.jpg.asset.json";
import entitiesFilm from "@/assets/entities-teaser.mp4.asset.json";
import entitiesWebm from "@/assets/entities-teaser.webm.asset.json";
import entitiesPoster from "@/assets/entities-teaser-poster.jpg.asset.json";
import butohFilm from "@/assets/butoh-teaser.mp4.asset.json";
import butohWebm from "@/assets/butoh-teaser.webm.asset.json";
import butohPoster from "@/assets/butoh-teaser-poster.jpg.asset.json";
import luizaFinal2Film from "@/assets/luiza-final-2.mp4.asset.json";
import luizaFinal2Webm from "@/assets/luiza-final-2.webm.asset.json";
import luizaFinal2Poster from "@/assets/luiza-final-2-poster.jpg.asset.json";
import luizaFinal3Film from "@/assets/luiza-final-3.mp4.asset.json";
import luizaFinal3Webm from "@/assets/luiza-final-3.webm.asset.json";
import luizaFinal3Poster from "@/assets/luiza-final-3-poster.jpg.asset.json";

/** Supplied work clips, in their home-cover playback order. The 7 Distúrbios clips stay out by request. */
export const homeFilms = [
  { id: "entities", src: entitiesFilm.url, webm: entitiesWebm.url, poster: entitiesPoster.url },
  { id: "butoh", src: butohFilm.url, webm: butohWebm.url, poster: butohPoster.url },
  {
    id: "luiza-final-2",
    src: luizaFinal2Film.url,
    webm: luizaFinal2Webm.url,
    poster: luizaFinal2Poster.url,
  },
  {
    id: "luiza-final-3",
    src: luizaFinal3Film.url,
    webm: luizaFinal3Webm.url,
    poster: luizaFinal3Poster.url,
  },
  { id: "fetiche", src: h_fetiche.url, poster: h_fetiche_p.url },
  { id: "primeiro-corte", src: h_primeiro_corte.url, poster: h_primeiro_corte_p.url },
  { id: "6-de-abril", src: h_6_de_abril.url, poster: h_6_de_abril_p.url },
  { id: "music-on", src: h_music_on.url, poster: h_music_on_p.url },
];
